// extracted by mini-css-extract-plugin
export var btnContainer = "SectionBlog-module--btnContainer--ba0c7";
export var btnMedium = "SectionBlog-module--btnMedium--864e9";
export var heading = "SectionBlog-module--heading--dcbb4";
export var sectionBlog = "SectionBlog-module--sectionBlog--e0e4e";